module.exports = __webpack_public_path__ + "static/media/YF91_1.1dec9069.jpg";